import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EmailConfirmationPage } from '../pages/email-confirmation/email-confirmation';

const emailConfirmationSearchSchema = z.object({
  travelId: z.string(),
  email: z.string(),
});

export const Route = createFileRoute('/email-confirmation')({
  component: EmailConfirmationPage,
  validateSearch: emailConfirmationSearchSchema,
});
